import { useState } from "react";

export default function useLocalStorage<T>(
  key: string,
  initialValue: T,
): [T, (value: T | ((prevValue: T) => T)) => void] {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = (value: T | ((prevValue: T) => T)): void => {
    try {
      setStoredValue((prev: T) => {
        let newValue: T;
        if (isUpdaterFunction(value)) {
          newValue = value(prev);
        } else {
          newValue = value;
        }
        window.localStorage.setItem(key, JSON.stringify(newValue));
        return newValue;
      });
    } catch (error) {
      console.error(error);
    }
  };

  return [storedValue, setValue];
}

function isUpdaterFunction<T>(value: T | ((prevValue: T) => T)): value is (prevValue: T) => T {
  return typeof value === "function";
}
